import { render } from "./ShareLink.vue?vue&type=template&id=3c7407f0&scoped=true"
import script from "./ShareLink.vue?vue&type=script&lang=js"
export * from "./ShareLink.vue?vue&type=script&lang=js"

import "./ShareLink.vue?vue&type=style&index=0&id=3c7407f0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3c7407f0"

export default script